<template>
    <v-snackbar
        bottom
        right
        :timeout="-1"
        light
        v-model="show"
        min-width="150px"
    >
        <div class="text-subtitle-1">
            We use cookies to anonymously track website statistics
        </div>
        <div class="d-flex mt-2">
            <div class="text-body-2 mr-2">
                To find out more see our
                <a
                    target="_blank"
                    :href="$page.props.company_info.privacy_policy"
                >
                    privacy policy
                </a>
            </div>
            <v-btn @click="closePopup" class="ml-auto" small> Okay! </v-btn>
        </div>
    </v-snackbar>
</template>

<script>
export default {
    name: "CookiePopup",

    data() {
        return {
            show: false,
        };
    },

    mounted() {
        if (!this.localStorageGet("cookiePolicyAccepted")) {
            this.show = true;
        }
    },

    methods: {
        closePopup() {
            this.show = false;
            this.localStorageSet("cookiePolicyAccepted", "true");
        },

        localStorageSet(key, value) {
            try {
                return localStorage.setItem(key, value);
            } catch (e) {
                return null;
            }
        },

        localStorageGet(key) {
            try {
                return localStorage.getItem(key);
            } catch (e) {
                return null;
            }
        },
    },
};
</script>

<style scoped></style>
